import FieldMultiselect from "../multiselect/multiselect";
import FieldConfig from "../../proto/field-config";

export default class FieldMultiselectDynamic extends FieldMultiselect {

    public _options     : any       // dynamic options // special - dynamic (!)

    constructor(config:FieldConfig) {
        super(config);

        this._options               = null;
    }

    // assumed to be redefined
    getOptions() {
        return this._options || [];
    }

    // this is for view (!) i.e. dropdown _getOptions and multiselct _getOptions
    _getOptions(value:any) {
        // value is array

        if (value) {
            // !!! '==' is intentional to make no difference for number and string
            const options = _.filter(this.getOptions(), option => value.includes(option.value));
            if (options) return options;
        }

        return false;
    }


    searchValue(value:any) {
        const options = this._getOptions(value);
        return options ? options.join(' ').toLowerCase() : '';
    }



    /*** IMPORT EXPORT ***/

    toJson() {
        let result = super.toJson();
        result.options = this.getOptions();
        return result;
    }
}